/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type EnterFilingFactsInput = {
  distributions: Scalars['Float']['input'];
  fiduciaryFees: Scalars['Float']['input'];
  filingId: Scalars['String']['input'];
  mustDistributeIncome: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  enterFilingFacts: MutationResponse;
  openClient: MutationResponse;
  openFiling: MutationResponse;
  publishRulePackage: MutationResponse;
  requestCalculation: MutationResponse;
  uploadFile: UploadTicket;
};


export type MutationEnterFilingFactsArgs = {
  input: EnterFilingFactsInput;
};


export type MutationOpenClientArgs = {
  input: OpenClientInput;
};


export type MutationOpenFilingArgs = {
  input: OpenFilingInput;
};


export type MutationPublishRulePackageArgs = {
  input: PublishRulePackageInput;
};


export type MutationRequestCalculationArgs = {
  input: RequestCalculationInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type OpenClientInput = {
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  fiduciaryName: Scalars['String']['input'];
};

export type OpenFilingInput = {
  clientId: Scalars['String']['input'];
  filingId: Scalars['String']['input'];
  rulePackageId: Scalars['String']['input'];
};

export type PublishRulePackageInput = {
  fileRef: Scalars['String']['input'];
  rulePackageId: Scalars['String']['input'];
  taxYear: Scalars['Float']['input'];
  version: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  uploadFileStatus?: Maybe<UploadFileStatus>;
  viewClients: Array<ViewClientsView>;
  viewRulePackages: Array<ViewRulePackagesView>;
};


export type QueryUploadFileStatusArgs = {
  fileId: Scalars['String']['input'];
};

export type RequestCalculationInput = {
  filingId: Scalars['String']['input'];
};

export type UploadFileInput = {
  byteSize: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type UploadFileStatus = {
  __typename?: 'UploadFileStatus';
  byteSize: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UploadTicket = {
  __typename?: 'UploadTicket';
  fileId: Scalars['ID']['output'];
  ticket: Scalars['String']['output'];
};

export type ViewClientsView = {
  __typename?: 'ViewClientsView';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  fiduciaryName?: Maybe<Scalars['String']['output']>;
};

export type ViewRulePackagesView = {
  __typename?: 'ViewRulePackagesView';
  rulePackageId: Scalars['String']['output'];
  taxYear?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ViewClientsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewClientsQueryQuery = { __typename?: 'Query', viewClients: Array<{ __typename: 'ViewClientsView', clientId: string, clientName?: string | null, fiduciaryName?: string | null }> };

export type ViewRulePackagesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewRulePackagesQueryQuery = { __typename?: 'Query', viewRulePackages: Array<{ __typename: 'ViewRulePackagesView', rulePackageId: string, taxYear?: number | null, version?: string | null }> };

export type UploadFileStatusQueryQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type UploadFileStatusQueryQuery = { __typename?: 'Query', uploadFileStatus?: { __typename: 'UploadFileStatus', id: string, fileName: string, contentType: string, byteSize: number, checksum: string, status: string } | null };

export type OpenClientMutationMutationVariables = Exact<{
  input: OpenClientInput;
}>;


export type OpenClientMutationMutation = { __typename?: 'Mutation', openClient: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type PublishRulePackageMutationMutationVariables = Exact<{
  input: PublishRulePackageInput;
}>;


export type PublishRulePackageMutationMutation = { __typename?: 'Mutation', publishRulePackage: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type OpenFilingMutationMutationVariables = Exact<{
  input: OpenFilingInput;
}>;


export type OpenFilingMutationMutation = { __typename?: 'Mutation', openFiling: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type EnterFilingFactsMutationMutationVariables = Exact<{
  input: EnterFilingFactsInput;
}>;


export type EnterFilingFactsMutationMutation = { __typename?: 'Mutation', enterFilingFacts: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type RequestCalculationMutationMutationVariables = Exact<{
  input: RequestCalculationInput;
}>;


export type RequestCalculationMutationMutation = { __typename?: 'Mutation', requestCalculation: { __typename: 'MutationResponse', success: boolean, error?: { __typename: 'MutationError', type: string, message?: string | null } | null } };

export type UploadFileMutationMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFileMutationMutation = { __typename?: 'Mutation', uploadFile: { __typename: 'UploadTicket', fileId: string, ticket: string } };


export const ViewClientsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewClientsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"fiduciaryName"}}]}}]}}]} as unknown as DocumentNode<ViewClientsQueryQuery, ViewClientsQueryQueryVariables>;
export const ViewRulePackagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewRulePackagesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewRulePackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"rulePackageId"}},{"kind":"Field","name":{"kind":"Name","value":"taxYear"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<ViewRulePackagesQueryQuery, ViewRulePackagesQueryQueryVariables>;
export const UploadFileStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UploadFileStatusQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFileStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"byteSize"}},{"kind":"Field","name":{"kind":"Name","value":"checksum"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UploadFileStatusQueryQuery, UploadFileStatusQueryQueryVariables>;
export const OpenClientMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenClientMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenClientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OpenClientMutationMutation, OpenClientMutationMutationVariables>;
export const PublishRulePackageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishRulePackageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublishRulePackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishRulePackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PublishRulePackageMutationMutation, PublishRulePackageMutationMutationVariables>;
export const OpenFilingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenFilingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenFilingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openFiling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<OpenFilingMutationMutation, OpenFilingMutationMutationVariables>;
export const EnterFilingFactsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnterFilingFactsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnterFilingFactsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterFilingFacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<EnterFilingFactsMutationMutation, EnterFilingFactsMutationMutationVariables>;
export const RequestCalculationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestCalculationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestCalculationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RequestCalculationMutationMutation, RequestCalculationMutationMutationVariables>;
export const UploadFileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutationMutation, UploadFileMutationMutationVariables>;